import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import RadioButtons from "../../../../layouts/RadioButtons";
import { verifyCheckBoxes } from "../../../../utils/detail";
import FormTriggers from "../../../../layouts/FormTriggers";
import {
  OTPPaymentMode,
  OTPPayeeType,
  // OTPPayerAccount, // dead: OTP now from per-account require_otp flag in API dropdown
  TrancheNameList,
  PaymentTrancheRequiredTriggers,
  OfflinePaymentModes,
} from "../../../../utils/constant";
import { axios_instance } from "../../../../api/axios_instance";
import TrancheControlModal from "./TrancheControlModal";
import WithheldChargesModal from "./WithheldChargesModal";
import PaymentTrancheFormButtons from "./PaymentTrancheFormButtons";
import {
  addTrancheFunction,
  addUTRFunction,
  assignChecker,
  autoFillByIfsc,
  balTotalFunction,
  cancelPartPaymentFunction,
  changeAccTypeFunction,
  checkerValidateFunction,
  compareLedgerWithDisbAmtFunction,
  getFloatColorAndMsg,
  getPayerAcVal,
  getTrancheClsAndType,
  getTrancheNo,
  ifscMappingFunction,
  makerSubmissionFunction,
  otherSubmissionFunction,
  partPaymentSubmissionFunction,
  refreshFloatRuleFunction,
  resetDealerProfileFields,
  resetPaymentPrefillFields,
  superMakerSubmissionFunction,
  validateAccNumberFunction,
  validateOTPFunction,
} from "../../../../utils/TrancheFormFunctions";
import AddedTranche from "./AddedTranche";
import SuperMakerConfirmModal from "./SuperMakerConfirmModal";
import { toast } from "react-toastify";
import AssignCheckerModal from "./AssignCheckerModal";
import ApprovePaymentModal from "./ApprovePaymentModal";
import CancelPaymentModal from "./CancelPaymentModal";
import CommonTrancheDetails from "./CommonTrancheDetails";
import RefreshButton from "./RefreshButton";
import AmountMismatchModal from "./AmountMismatchModal";
import BankandPaymentDetails from "./BankandPaymentDetails";
import PayeeAndPayerDetails from "./PayeeAndPayerDetails";
import {
  DetailFormContext,
  DetailPageLoadingModalContext,
} from "../../../../ContextAPI/context";
import {
  decryptRequest,
  encryptRequest,
} from "../../../../utils/encryptdecryptrequest";
import ContainerLoading from "../../../../layouts/ContainerLoading";
import {
  checkPayeeNameHavAcc,
  getOfflinePayeeName,
} from "../../../../utils/helperFunctions";

const PaymentTranche = ({
  fieldValues,
  paymentDetails,
  user,
  isVerificationRequired,
  controlsystem,
  payleadData,
  RCLimit,
  fetchDetails,
  isMoneyReturnToBank,
  changeMoneyReturnToBank,
  caseDetails,
  fetchGallery,
}) => {
  const { stepDetails, checkpoints, isPartPayment, isTMSUser, isSuperMaker } =
    fieldValues;
  const checkerCheckpoints = checkpoints;

  const readOnlyUser = fieldValues.isReadOnlyUser;
  const { panelTitle, stepTitle } = useContext(DetailFormContext);

  let {
    disableMaker,
    disableRadioCls,
    btnDisplayHOD,
    btnDisplayPaylead,
    btnDisplayMakerPart,
    stageDraftVal,
    substageDraftVal,
    showUTRSaveButton,
    disable,
  } = stepDetails;

  const utrEnabled = !disableMaker || readOnlyUser ? false : true;
  const showUTRButton = [];
  paymentDetails.forEach(() => {
    showUTRButton.push(utrEnabled);
  });
  const initialState = {
    payeeType: "",
    paymentMode: "",
    payerAccount: "",
    trancheName: "",
    withHeldAmount: caseDetails.with_held_amount,
    addedTrancheData: {},
    payeeTypeList: [],
    paymentTrancheDetails: {
      controlSystem: controlsystem,
      floatResp: {},
      cancellationData: [],
      trancheNameListData: [],
      forClosureData: [],
      isAuthorizedAccess: true,
    },
    isPartialPayment: caseDetails.is_partial_payment
      ? caseDetails.is_partial_payment
      : caseDetails.with_held_amount
        ? "1"
        : "",
    disabled_authTrancheBtn: null,
    disabled_approveTrancheBtn: true,
    curPayCount: 0,
    showNextTrancheCell: false,
    showUTRButton,
    showSuperMakerConfirmModal: false,
    showTrancheControlModal: false,
    showWithheldChargesModal: false,
    withHeldChargesInputDisabled: false,
    withHeldChargesBtnDisplay: false,
    withHeldChargesPayCount: 0,
    withHeldChargesAdjustmentAmount: 0,
    withHeldChargesAdjustmentChargesDisplay: false,
    withHeldChargesAction: "manual",
    withHeldChargesOtherReasonDisplay: true,
    withHeldChargesCheckboxVal: false,
    withHeldChargesIndiCheckboxVal: {},
    withheldChargesInputValues: {},
    totalWithheldCharges: 0,
    showAmountMismatchModal: false,
    showAssignCheckerModal: false,
    showApprovePaymentModal: false,
    showCancelPaymentModal: false,
    mismatchBtnClickFunc: "othersubmission",
    cancelReason: "",
    spinClass: "",
  };

  const [otherSubmissionParams, setOtherSubmissionParams] = useState({});

  const initialFormFieldState = [...paymentDetails];
  for (let i = 0; i < initialFormFieldState.length; i++) {
    if (typeof initialFormFieldState[i].floatProof === "undefined") {
      initialFormFieldState[i].floatProof = null;
    }
    initialFormFieldState[i].floatResp = null;
    const temp = initialFormFieldState[i];
    const cond = i === initialFormFieldState.length - 1 && btnDisplayMakerPart;
    temp.disabledPaymentMode = cond ? false : disableMaker;
    temp.disabledPayeeType = cond ? false : disableMaker;
    temp.disabledPayableAcNumber = cond ? false : disableMaker;
    temp.confirmPayeeAcNumber =
      temp?.save_as_draft !== 0 && temp?.payee_ac_number
        ? temp.payee_ac_number
        : "";
    temp.hideLastPayDiv =
      i === initialFormFieldState.length - 1 && btnDisplayMakerPart
        ? false
        : disableMaker;
    temp.existed_payee_name = temp.payeeNameVal;
    temp.existed_payee_account = temp.payee_ac_number;
    PaymentTrancheRequiredTriggers.forEach((trigger) => {
      const triggerVal = checkerCheckpoints[`${trigger.name}_${i + 1}`];
      if (!trigger.common && triggerVal !== null && triggerVal !== undefined) {
        temp[`${trigger.name}trigger`] =
          checkerCheckpoints[`${trigger.name}_${i + 1}`];
      }
    });
  }

  const dropdownContainer = useRef(null);
  const dropdownContainers = useMemo(
    () => [dropdownContainer],
    [dropdownContainer],
  );

  const closeAllDropdowns = useCallback(
    (target) => {
      dropdownContainers
        .filter((container) => container !== target)
        .forEach((container) => {
          const ul = container.current;
          if (ul && ul.classList.contains("visible")) {
            ul.classList.remove("visible");
            ul.style.display = "none";
          }
        });
    },
    [dropdownContainers],
  );

  PaymentTrancheRequiredTriggers.forEach((trigger) => {
    if (trigger.common) {
      const triggerVal = checkerCheckpoints[trigger.name];
      if (triggerVal !== null && triggerVal !== undefined) {
        initialState[`${trigger.name}trigger`] =
          checkerCheckpoints[trigger.name];
      }
      return;
    }
  });

  const [state, setState] = useState(initialState);
  const [formFieldState, setFormFieldState] = useState(initialFormFieldState);
  const [floatProof, setFloatProof] = useState(null);

  const { setShowLoadingModal } = useContext(DetailPageLoadingModalContext);
  const [isLoading, setIsLoading] = useState(true);

  const checkIsPaymentReceivedByBank =
    checkerCheckpoints.is_payment_received_by_bank === "1" ? true : false;
  const uncheckIsPaymentReceivedByBank =
    checkerCheckpoints.is_payment_received_by_bank === "0" ? true : false;

  const btnDisplayMakerLead = false;

  const dtsPaymentMax = paymentDetails.length
    ? paymentDetails.length
    : caseDetails.dts_pay_count
      ? caseDetails.dts_pay_count
      : 1;

  const saveAsDraft =
    paymentDetails.length &&
    paymentDetails[paymentDetails.length - 1].pay_count === dtsPaymentMax &&
    paymentDetails[paymentDetails.length - 1].save_as_draft;

  let disableApproveBtn = false;

  const lastCancellationDataArr = state.paymentTrancheDetails.cancellationData[
    paymentDetails.length - 1
  ]
    ? state.paymentTrancheDetails.cancellationData[paymentDetails.length - 1]
    : [];

  const trancheForClosureData = state.paymentTrancheDetails.forClosureData[
    paymentDetails.length - 1
  ]
    ? state.paymentTrancheDetails.forClosureData[paymentDetails.length - 1]
    : {};
  let disableValues = true;

  const isForeclosure =
    Object.keys(trancheForClosureData).length &&
    trancheForClosureData.release_foreclosure_amount > 0;

  const isCancellation = Object.keys(lastCancellationDataArr).length > 1;

  if (isForeclosure || isCancellation) {
    disableValues = false;
  }

  const handleDocumentClick = useCallback(
    (e) => {
      if (
        !dropdownContainers.some(
          (container) =>
            container.current && container.current.contains(e.target),
        )
      ) {
        closeAllDropdowns();
      }
    },
    [closeAllDropdowns, dropdownContainers],
  );

  const fetchBalAmount = (
    idx,
    trancheNameListData,
    updateState,
    addedTranche,
    firstRender,
  ) => {
    let withheldCharges = 0;
    if (idx) {
      trancheNameListData.forEach((val) => {
        if (val.isChecked) withheldCharges += parseInt(val.amount);
      });
    }
    const result = balTotalFunction(
      idx,
      formFieldState,
      state,
      setState,
      withheldCharges,
      addedTranche,
      firstRender,
    );
    if (updateState) setFormFieldState([...formFieldState]);
    showToast(result);
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const caseDetailsCopy = { ...caseDetails, dts_pay_count: dtsPaymentMax };
      let reqData = encryptRequest({ caseDetails: caseDetailsCopy });
      let floatStatusResp = await axios_instance({
        url: "/dts/checkFloatStatus",
        method: "POST",
        data: { reqData },
      });
      floatStatusResp = decryptRequest(floatStatusResp.data.resData);
      console.log({ dtsPaymentMax, floatStatusResp });
      if (floatStatusResp && floatStatusResp.result) {
        // if (
        //   +floatStatusResp.result.float_status === 1 ||
        //   floatStatusResp.result.is_proof_uploaded
        // ) {
        //   formFieldState[dtsPaymentMax - 1].is_payment_received_by_bank = 1;
        // } else {
        //   formFieldState[dtsPaymentMax - 1].is_payment_received_by_bank = 0;
        // }
        formFieldState[dtsPaymentMax - 1].floatResp = floatStatusResp.result;
        formFieldState[dtsPaymentMax - 1].float_status =
          floatStatusResp.result.float_status;
        formFieldState[dtsPaymentMax - 1].float_doc_id =
          floatStatusResp.result.document_id || 0;
      }
      setFormFieldState([...formFieldState]);
      reqData = encryptRequest({
        disbursement_id: caseDetails.id,
        total_count: paymentDetails.length,
      });
      let foreClosureOrCancellationRes = await axios_instance({
        url: "/dts/getForeClosureOrCancellationData",
        method: "POST",
        data: { reqData },
      });
      foreClosureOrCancellationRes = decryptRequest(
        foreClosureOrCancellationRes.data.resData,
      );

      reqData = encryptRequest({
        net_disbursement_amount: caseDetails.net_disbursement_amount,
        control_type: controlsystem.type,
        user_id: user.id,
      });
      let authorisedAccessResp = await axios_instance({
        url: "/dts/getAuthorizationAccess",
        method: "POST",
        data: { reqData },
      });
      authorisedAccessResp = decryptRequest(authorisedAccessResp.data.resData);

      reqData = encryptRequest({
        disbursement_id: caseDetails.id,
        count: dtsPaymentMax,
      });
      let trancheNameListResp = await axios_instance({
        url: "/dts/getTrancheNameList",
        method: "POST",
        data: { reqData },
      });
      trancheNameListResp = decryptRequest(trancheNameListResp.data.resData);

      reqData = encryptRequest({
        lead_id: caseDetails.finance_lead_id
          ? caseDetails.finance_lead_id
          : caseDetails.lead_id,
      });
      let dropDownDataResp = await axios_instance({
        url: "/dts/getPaymentTrancheDropdownData",
        method: "POST",
        data: { reqData },
      });
      dropDownDataResp = decryptRequest(dropDownDataResp.data.resData);

      const cancellationDataResp =
        foreClosureOrCancellationRes.cancellationData;

      cancellationDataResp.forEach((data, idx) => {
        data = data ? data : {};
        formFieldState[idx].cancellationChargesVal =
          data.cancellationChargesVal;
      });

      const trancheNameListData = trancheNameListResp.result;
      let totalWithheldCharges = 0;
      trancheNameListData.forEach((data) => {
        totalWithheldCharges += data.isChecked ? 0 : +data.amount;
      });

      formFieldState.forEach((payment) => {
        payment.trancheNameListData = trancheNameListData;
      });

      setFormFieldState((prevState) => [...prevState]);

      setState((prevState) => ({
        ...prevState,
        payeeTypeList: dropDownDataResp.result.payeeTypes,
        payerAccount: dropDownDataResp.result.payerAccount,
        offlineDefaultAccount: dropDownDataResp.result.offlineDefaultAccount,
        totalWithheldCharges,
        paymentTrancheDetails: {
          ...state.paymentTrancheDetails,
          floatResp: floatStatusResp.result,
          cancellationData: cancellationDataResp,
          trancheNameListData,
          forClosureData: foreClosureOrCancellationRes.forClosureData,
          isAuthorizedAccess: authorisedAccessResp.result,
        },
        checkBalAmount: true,
      }));
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [handleDocumentClick]);

  useEffect(() => {
    if (state.checkBalAmount) {
      if (!disableMaker) {
        fetchBalAmount(
          formFieldState.length - 1,
          state.paymentTrancheDetails.trancheNameListData,
          false,
          false,
          true,
        );
      }
    }
    setState((prevState) => ({ ...prevState, checkBalAmount: false }));
  }, [state.checkBalAmount]);

  const otherSubmissionFunc = async (type, stage, subStage, formName, cond) => {
    setIsLoading(true);
    setShowLoadingModal(true);
    setOtherSubmissionParams((prevState) => ({
      ...prevState,
      type,
      stage,
      subStage,
      formName,
    }));

    const result = await otherSubmissionFunction(
      formFieldState,
      state,
      setState,
      type,
      stage,
      subStage,
      caseDetails,
      formName,
      payleadData,
      paymentDetails,
      controlsystem.type,
      controlsystem.reasons ? controlsystem.reasons : [],
      cond,
    );

    if (result && result.msg && !result.error) {
      try {
        await fetchDetails();
      } catch (error) {
        result.msg = "Internal Server Error";
        result.error = true;
      }
    }

    if (isMoneyReturnToBank) changeMoneyReturnToBank(false);

    setState((prevState) => ({
      ...prevState,
      showApprovePaymentModal: false,
      showCancelPaymentModal: false,
    }));
    setShowLoadingModal(false);
    setIsLoading(false);

    showToast(result);
  };
  useEffect(() => {
    if (isMoneyReturnToBank) {
      otherSubmissionFunc("submit", "3", "11", "dtStage1");
    }
  }, [isMoneyReturnToBank]);
  const removeTrancheErrorClass = (
    idx,
    classId,
    formFieldState,
    setFormFieldState,
    updateState = false,
  ) => {
    formFieldState[idx][`${classId}Class`] = "";
    formFieldState[idx][`error${classId}Msg`] = null;
    if (updateState) setFormFieldState([...formFieldState]);
  };
  const handleInputChange = async (e, idx, inputName) => {
    const { value, type } = e.target;
    formFieldState[idx] = { ...formFieldState[idx], [inputName]: value };

    if (inputName === "payment_mode") {
      // if (["DD", "ECHK", "CHK"].includes(value)) {
      //   formFieldState[idx].forceEditable = true;
      //   resetPaymentPrefillFields(idx, formFieldState);
      // } else {
      try {
        // let trancheNo = false;
        // if (+formFieldState[idx]?.payeeTypeVal === 7) {
        //   trancheNo = true;
        // }
        const index = +caseDetails?.dts_pay_count - 1;
        const tuTranche = +paymentDetails[index]?.tu_tranche_no;

        // const tranche_no =
        //   tuTranche !== 0
        //     ? tuTranche
        //     : trancheNo
        //     ? "-1"
        //     : caseDetails?.dts_pay_count;
        const tranche_no =
          tuTranche !== 0 ? tuTranche : caseDetails?.dts_pay_count;
        const response = await axios_instance({
          url: "/dts/getPrefillTUTranchewiseData",
          method: "POST",
          data: {
            lead_id: caseDetails?.finance_lead_id,
            tranche_no: tranche_no,
          },
        });
        if (response.status === 200) {
          const result = response.data.result;
          let offlinePayeeName = "";
          if (["DD", "ECHK", "CHK"].includes(value) && disableValues) {
            offlinePayeeName = getOfflinePayeeName(result);
          }

          formFieldState[idx].payeeTypeVal = result.payee_type;
          formFieldState[idx].payeeNameVal = offlinePayeeName
            ? offlinePayeeName
            : result?.payee_name;
          formFieldState[idx].payee_ac_number = result.payee_account;
          formFieldState[idx].payee_ifsc_code = result.ifsc_code;
          formFieldState[idx].payee_bank_name = result.bank;
          formFieldState[idx].payee_branch_name = result.branch;
          const fieldMapping = {
            payableAcNumber: result.payee_account,
            paymentMode: result.payee_type,
            payeeType: result.payee_type,
            payeeName: result.payee_name,
            payeeAccountNo: result.payee_account,
            confirmPayeeAcNumber: result.payee_account,
            payeeIFSC: result.ifsc_code,
            payeeBankName: result.bank,
            payeeBranchName: result.branch,
          };

          Object.entries(fieldMapping).forEach(([classId, value]) => {
            if (value && value !== "") {
              removeTrancheErrorClass(
                idx,
                classId,
                formFieldState,
                setFormFieldState,
                true,
              );
            }
          });
        } else {
          resetPaymentPrefillFields(idx, formFieldState);
        }
      } catch (error) {
        resetPaymentPrefillFields(idx, formFieldState);
      }
      formFieldState[idx].forceEditable = false;
      setFormFieldState([...formFieldState]);
      // }
    }
    if (inputName === "payable_ac_number") {
      await changeAccTypeFunc(idx);
      return setFormFieldState([...formFieldState]);
    }

    if (inputName === "payeeTypeVal") {
      if (!isTMSUser) {
        if ([1, 7, 9].includes(+value)) {
          try {
            const response = await axios_instance({
              url: "/dts/getDealerProfile",
              method: "POST",
              data: {
                lead_id: caseDetails.finance_lead_id,
                dealer_id: caseDetails.dealer_id,
                payee_type_val: +value,
              },
            });
            if (response.status === 200) {
              const result = response.data.result;
              formFieldState[idx].payeeNameVal = result.payee_name;
              formFieldState[idx].payee_ac_number = result.payee_account;
              formFieldState[idx].payee_ifsc_code = result.ifsc_code;
              formFieldState[idx].payee_bank_name = result.bank;
              formFieldState[idx].payee_branch_name = result.branch;
              await autoFillByIfsc(idx, result.ifsc_code, formFieldState);
            } else {
              resetDealerProfileFields(idx, formFieldState);
            }
          } catch (error) {
            resetDealerProfileFields(idx, formFieldState);
          }
        } else {
          resetDealerProfileFields(idx, formFieldState);
        }
      }
      await getPayerAcVal(idx, formFieldState, caseDetails);
      return setFormFieldState([...formFieldState]);
    }

    if (inputName === "payable_rtgs_cheque_number")
      formFieldState[idx].showChequeInput = true;

    if (!["text", "password"].includes(type))
      await getPayerAcVal(idx, formFieldState, caseDetails);
    setFormFieldState([...formFieldState]);
  };

  const handleRadioChange = async (value, idx, radioName) => {
    if (idx === -1) {
      setState((prevState) => ({ ...prevState, [radioName]: value }));
      return;
    }
    const newObj = {
      ...formFieldState[idx],
      [radioName]: value,
    };
    formFieldState[idx] = newObj;
    if (idx >= 0) {
      await getPayerAcVal(idx, formFieldState, caseDetails);
      await compareLedgerWithDisbAmtFunc(idx);
    }
    setFormFieldState([...formFieldState]);
  };

  const handleCheckboxChange = (e, filterName, idx) => {
    if (!idx) idx = paymentDetails.length - 1;
    const { name, checked } = e.target;
    let withheldCharges = 0,
      temp = [],
      selected_tranche_value = 0,
      tranche_value = 0,
      tranche_name = {};

    const disbursePayableAmt = formFieldState[idx].netAmountVal;

    if (name === "selectall") {
      temp = formFieldState[idx][filterName].map((value) => {
        if (!checked) {
          tranche_name.deselected = {
            ...tranche_name.deselected,
            [value.label]: value.amount,
          };
          withheldCharges += parseInt(value.amount);
          tranche_value = withheldCharges;

          state.withHeldChargesIndiCheckboxVal[TrancheNameList[value.label]] =
            true;
          state.withheldChargesInputValues[TrancheNameList[value.label]] =
            value.amount;
          state.withHeldChargesOtherReasonDisplay = true;
        } else {
          tranche_name.selected = {
            ...tranche_name.selected,
            [value.label]: value.amount,
          };

          selected_tranche_value += parseInt(value.amount);
        }
        return { ...value, isChecked: checked };
      });
    } else {
      temp = formFieldState[idx][filterName].map((value) => {
        let chk = value.isChecked;
        if (value.label === name) chk = checked;
        if (!chk) {
          tranche_name.deselected = {
            ...tranche_name.deselected,
            [value.label]: value.amount,
          };
          withheldCharges += parseInt(value.amount);
          tranche_value = withheldCharges;
          state.withHeldChargesIndiCheckboxVal[TrancheNameList[value.label]] =
            true;
          state.withheldChargesInputValues[TrancheNameList[value.label]] =
            value.amount;
          if (name === "Other") {
            state.withHeldChargesOtherReasonDisplay = true;
          }
        } else {
          tranche_name.selected = {
            ...tranche_name.selected,
            [value.label]: value.amount,
          };

          selected_tranche_value += parseInt(value.amount);
        }
        return value.label === name ? { ...value, isChecked: checked } : value;
      });
    }

    setState({ ...state, totalWithheldCharges: withheldCharges });

    formFieldState[idx][filterName] = temp;
    formFieldState[idx].tranche_name = tranche_name;

    formFieldState[idx].paidAmountVal = selected_tranche_value;
    formFieldState[idx].tranche_value = withheldCharges;

    formFieldState[idx].disburse_bal_amt = withheldCharges;

    formFieldState[idx].with_held_charges = withheldCharges;

    setFormFieldState([...formFieldState]);
  };

  const handleFloatProofUpload = async (e, idx, customPayCount = null) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
    ];
    if (!allowedTypes.includes(file.type)) {
      alert("Only PDF, JPG, JPEG and PNG files are allowed");
      e.target.value = "";
      return;
    }

    try {
      setShowLoadingModal(true);
      const formData = new FormData();
      formData.append("file", file);
      formData.append("disbursement_id", caseDetails.id);
      formData.append(
        "lead_id",
        caseDetails.finance_lead_id || caseDetails.lead_id,
      );
      formData.append("pay_count", customPayCount || dtsPaymentMax);

      const uploadResp = await axios_instance({
        url: "/dts/uploadFloatProof",
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (uploadResp?.data?.success || uploadResp?.data?.status === 1) {
        if (typeof fetchGallery === "function") {
          await fetchGallery();
        }
        handleRadioChange(1, idx, "is_payment_received_by_bank");

        formFieldState[idx].float_doc_id = uploadResp.data.result.documentId;
        formFieldState[idx].floatResp = {
          ...formFieldState[idx].floatResp,
          is_proof_uploaded: true,
          document_id: uploadResp.data.result.documentId,
        };
        setFormFieldState([...formFieldState]);

        setState((prevState) => ({
          ...prevState,
          paymentTrancheDetails: {
            ...prevState.paymentTrancheDetails,
            floatResp: {
              ...prevState.paymentTrancheDetails.floatResp,
              is_proof_uploaded: true,
              document_id: uploadResp.data.result.documentId,
            },
          },
        }));

        showToast({ msg: "Float approval uploaded successfully." });
      } else {
        e.target.value = "";
        alert("Upload failed");
      }
    } catch (err) {
      console.error(err);
      e.target.value = "";
      alert("Upload failed");
    } finally {
      setShowLoadingModal(false);
    }
  };

  const handleFloatProofDelete = async (idx) => {
    try {
      setShowLoadingModal(true);
      const documentId =
        formFieldState[idx].floatResp?.document_id ||
        state.paymentTrancheDetails?.floatResp?.document_id;
      const deleteResp = await axios_instance({
        url: "/dts/deleteFloatProof",
        method: "POST",
        data: { documentId },
      });

      if (deleteResp?.data?.success || deleteResp?.data?.status === 1) {
        if (typeof fetchGallery === "function") {
          await fetchGallery();
        }

        handleRadioChange(0, idx, "is_payment_received_by_bank");

        formFieldState[idx].float_doc_id = 0;
        formFieldState[idx].floatResp = {
          ...formFieldState[idx].floatResp,
          is_proof_uploaded: false,
          document_id: null,
        };
        setFormFieldState([...formFieldState]);

        setState((prevState) => ({
          ...prevState,
          paymentTrancheDetails: {
            ...prevState.paymentTrancheDetails,
            floatResp: {
              ...prevState.paymentTrancheDetails.floatResp,
              is_proof_uploaded: false,
              document_id: null,
            },
          },
        }));

        showToast({ msg: "Float approval deleted successfully." });
      } else {
        alert("Delete failed");
      }
    } catch (err) {
      console.error(err);
      alert("Delete failed");
    } finally {
      setShowLoadingModal(false);
    }
  };

  const handleTriggerChange = (count, value, triggerFieldName) => {
    triggerFieldName = count ? triggerFieldName.slice(0, -1) : triggerFieldName;
    const trigger = PaymentTrancheRequiredTriggers.find(
      (trigger) => trigger.name === triggerFieldName,
    );
    if (!trigger) return;
    if (count) {
      count = +count;
      formFieldState[count - 1][`${triggerFieldName}trigger`] = value;
      formFieldState[count - 1][`show${trigger.errClass}TriggerError`] = false;
      setFormFieldState([...formFieldState]);
    } else {
      state[`${triggerFieldName}trigger`] = value;
      state[`show${trigger.errClass}TriggerError`] = false;
      setState({ ...state });
    }
  };

  const toggleDropDown = (container, e) => {
    closeAllDropdowns(container);
    const ul = container.current;
    if (ul.classList.contains("visible")) {
      ul.classList.remove("visible");
      ul.style.display = "none";
    } else {
      ul.classList.add("visible");
      ul.style.display = "block";
    }
    e.stopPropagation();
  };

  const toggleUTRButton = (idx, e) => {
    e.preventDefault();
    const showUTRButton = state.showUTRButton;
    showUTRButton[idx] = !showUTRButton[idx];
    setState({ ...state, showUTRButton });
  };

  const openTrancheControlModal = (pay_count, e) => {
    e.preventDefault();
    setState({
      ...state,
      showTrancheControlModal: true,
      curPayCount: pay_count,
    });
    e.stopPropagation();
  };

  const toggleCancellationTooltip = (idx) => {
    formFieldState[idx].showCancellationTooltip =
      !formFieldState[idx].showCancellationTooltip;
    setFormFieldState([...formFieldState]);
  };

  const compareLedgerWithDisbAmtFunc = async (idx) => {
    const result = await compareLedgerWithDisbAmtFunction(
      idx,
      formFieldState,
      caseDetails.id,
    );
    showToast(result);
  };

  const changeAccTypeFunc = async (idx) => {
    await changeAccTypeFunction(idx, state, formFieldState, caseDetails);
  };

  const cancelPartPaymentFunc = () => {
    cancelPartPaymentFunction(formFieldState);
    setFormFieldState([...formFieldState]);
  };

  const validateAccNumberFunc = (idx) => {
    validateAccNumberFunction(
      idx,
      formFieldState,
      setFormFieldState,
      state,
      setState,
    );
  };

  const ifscMappingFunc = async (idx) => {
    await ifscMappingFunction(idx, formFieldState);
    setFormFieldState([...formFieldState]);
  };

  const validateOTP = async (e, idx) => {
    await validateOTPFunction(
      e,
      idx,
      formFieldState,
      setFormFieldState,
      state,
      setState,
      caseDetails.finance_lead_id,
    );
  };

  const addUTR = async (idx) => {
    const result = await addUTRFunction(
      idx,
      formFieldState,
      setFormFieldState,
      caseDetails,
      dtsPaymentMax,
    );
    showToast(result);
  };

  const addTrancheFunc = async () => {
    const res = await addTrancheFunction(
      formFieldState.length,
      formFieldState,
      setFormFieldState,
      state,
      setState,
      caseDetails,
      paymentDetails,
    );
    const currentFloat =
      state.paymentTrancheDetails?.floatResp?.float_status === 1 ||
      state.paymentTrancheDetails?.floatResp?.is_proof_uploaded
        ? 1
        : 0;
    formFieldState.push({
      tuTrancheDetails: [],
      transactionUndertaking: {},
      trancheNameListData: [],
      cancellationData: [],
      showCancellationTooltip: false,
      showUTRButton: utrEnabled,
      addedTranche: true,
      is_payment_received_by_bank: currentFloat,
      floatResp: state.paymentTrancheDetails?.floatResp,
      float_status: state.paymentTrancheDetails?.floatResp?.float_status,
    });
    setFormFieldState([...formFieldState]);
    setState({ ...state, addedTrancheData: res });
    showToast(res);
  };

  const refreshFloatRuleFunc = async (lead_id, customIdx = null) => {
    const targetIdx =
      customIdx !== null ? customIdx : formFieldState.length - 1;
    const targetPayCount = targetIdx + 1;
    const result = await refreshFloatRuleFunction(
      state,
      setState,
      caseDetails,
      targetPayCount,
    );
    if (+result?.float_status === 1 || result?.is_proof_uploaded) {
      formFieldState[targetIdx].is_payment_received_by_bank = 1;
    } else {
      formFieldState[targetIdx].is_payment_received_by_bank = 0;
    }
    formFieldState[targetIdx].floatResp = {
      float_color: result.float_color,
      float_status: result.float_status,
      float_msg: result.float_msg,
      is_proof_uploaded:
        result.is_proof_uploaded ||
        formFieldState[targetIdx].floatResp?.is_proof_uploaded,
      document_id:
        result.document_id || formFieldState[targetIdx].floatResp?.document_id,
    };
    formFieldState[targetIdx].float_status = result.float_status;
    setFormFieldState([...formFieldState]);

    showToast(result);
    return result;
  };

  const makerSubmissionFunc = async (idx, type) => {
    setShowLoadingModal(true);
    setIsLoading(true);
    const result = await makerSubmissionFunction(
      idx,
      formFieldState,
      setFormFieldState,
      state,
      setState,
      type,
      stageDraftVal,
      substageDraftVal,
      caseDetails,
      user,
      "dtStage2",
      payleadData,
    );

    if (result && result.msg && !result.error) {
      try {
        await fetchDetails();
      } catch (error) {
        result.msg = "Internal Server Error";
        result.error = true;
      }
    }
    showToast(result);
    setShowLoadingModal(false);
    setIsLoading(false);
  };

  const partPaymentSubmissionFunc = async (idx, type, stage, subStage) => {
    setShowLoadingModal(true);
    setIsLoading(true);
    const result = await partPaymentSubmissionFunction(
      idx,
      caseDetails,
      formFieldState,
      setFormFieldState,
      state,
      setState,
      type,
      stage,
      subStage,
      user,
      payleadData,
    );

    if (result && result.msg && !result.error) {
      try {
        await fetchDetails();
        setState({ ...state, addedTrancheChecklist: true });
      } catch (error) {
        result.msg = "Internal Server Error";
        result.error = true;
      }
    }
    showToast(result);
    setShowLoadingModal(false);
    setIsLoading(false);
  };

  const superMakerSubmissionFunc = async (type, subStage, formName, cond) => {
    setShowLoadingModal(true);
    setIsLoading(true);
    const result = await superMakerSubmissionFunction(
      formFieldState,
      setFormFieldState,
      state,
      setState,
      type,
      subStage,
      caseDetails,
      formName,
      payleadData,
      paymentDetails,
      controlsystem.type,
      controlsystem.reasons ? controlsystem.reasons : [],
      cond,
      stepDetails.disable,
    );

    if (result && result.msg && !result.error) {
      try {
        await fetchDetails();
      } catch (error) {
        result.msg = "Internal Server Error";
        result.error = true;
      }
    }
    showToast(result);
    setShowLoadingModal(false);
    setIsLoading(false);
  };

  const checkerValidateFunc = async (idx, cond) => {
    const result = await checkerValidateFunction(
      idx,
      formFieldState,
      setFormFieldState,
      state,
      setState,
      caseDetails,
      "payment_tranche",
      cond,
      stepDetails.disable,
    );
    showToast(result);
  };

  const assignCheckerFunc = async (type, stage, subStage, formName) => {
    setShowLoadingModal(true);
    setIsLoading(true);
    const result = await assignChecker(
      formFieldState.length - 1,
      formFieldState,
      setFormFieldState,
      state,
      setState,
      type,
      stage,
      subStage,
      caseDetails,
      user,
      formName,
      payleadData,
      isPartPayment,
    );

    if (result && result.msg && !result.error) {
      try {
        await fetchDetails();
      } catch (error) {
        result.msg = "Internal Server Error";
        result.error = true;
      }
    }

    setState({
      ...state,
      showAssignCheckerModal: false,
    });
    showToast(result);
    setShowLoadingModal(false);
    setIsLoading(false);
  };

  const showToast = (result) => {
    const { msg, error } = result;
    if (!msg) return;
    if (error) {
      toast.dismiss();
      toast.error(msg, { theme: "colored" });
    } else {
      toast.dismiss();
      toast(
        <>
          <span className="glyphicon glyphicon-ok-sign"></span>
          {` ${msg}`}
        </>,
      );
    }
  };

  const changeCancelReason = (e) => {
    setState({ ...state, cancelReason: e.target.value });
  };

  const changeWithheldAmount = (
    withHeldAmount,
    openAssignCheckerModal,
    closeWithheldChargesModal,
  ) => {
    state.withHeldAmount = withHeldAmount;
    if (openAssignCheckerModal) state.showAssignCheckerModal = true;
    if (closeWithheldChargesModal) state.showWithheldChargesModal = false;
    setState(state);
  };

  return (
    <>
      {isLoading ? (
        <ContainerLoading galleryLoader={true} containerClass="row" />
      ) : (
        <form id="dtStage2" name="dtStage2">
          {state.showSuperMakerConfirmModal && (
            <SuperMakerConfirmModal
              closeSuperMakerConfirmModal={() =>
                setState({
                  ...state,
                  showSuperMakerConfirmModal: false,
                })
              }
            />
          )}

          {state.showTrancheControlModal && (
            <TrancheControlModal
              disbursement_id={caseDetails.id}
              pay_count={state.curPayCount}
              closeTrancheControlModal={() =>
                setState({
                  ...state,
                  showTrancheControlModal: false,
                })
              }
            />
          )}

          {state.showWithheldChargesModal && (
            <WithheldChargesModal
              caseDetails={caseDetails}
              closeWithheldChargesModal={() =>
                setState({
                  ...state,
                  showWithheldChargesModal: false,
                })
              }
              withHeldChargesInputDisabled={state.withHeldChargesInputDisabled}
              withHeldChargesBtnDisplay={state.withHeldChargesBtnDisplay}
              withHeldChargesPayCount={state.withHeldChargesPayCount}
              withHeldChargesAdjustmentAmount={
                state.withHeldChargesAdjustmentAmount
              }
              withHeldChargesAdjustmentChargesDisplay={
                state.withHeldChargesAdjustmentChargesDisplay
              }
              withHeldChargesAction={state.withHeldChargesAction}
              withHeldChargesOtherReasonDisplay={
                state.withHeldChargesOtherReasonDisplay
              }
              withHeldChargesCheckboxVal={state.withHeldChargesCheckboxVal}
              withHeldChargesIndiCheckboxVal={
                state.withHeldChargesIndiCheckboxVal
              }
              withheldChargesInputValues={state.withheldChargesInputValues}
              totalWithheldCharges={state.totalWithheldCharges}
              formFieldState={formFieldState}
              setFormFieldState={setFormFieldState}
              changeWithheldAmount={changeWithheldAmount}
            />
          )}
          {state.showAmountMismatchModal && (
            <AmountMismatchModal
              closeAmountMismatchModal={() =>
                setState({
                  ...state,
                  showAmountMismatchModal: false,
                })
              }
              mismatchBtnClickFunc={
                state.mismatchBtnClickFunc === "othersubmission"
                  ? () =>
                      otherSubmissionFunc(
                        otherSubmissionParams.type,
                        otherSubmissionParams.stage,
                        otherSubmissionParams.subStage,
                        otherSubmissionParams.formName,
                        true,
                      )
                  : () => checkerValidateFunc(dtsPaymentMax - 1, true)
              }
            />
          )}
          {state.showAssignCheckerModal && (
            <AssignCheckerModal
              id={caseDetails.id}
              user_id={user.id}
              assignCheckerFunc={assignCheckerFunc}
              closeAssignCheckerModal={() =>
                setState({
                  ...state,
                  showAssignCheckerModal: false,
                })
              }
            />
          )}
          {state.showApprovePaymentModal && (
            <ApprovePaymentModal
              RCLimit={RCLimit}
              stepDetails={stepDetails}
              otherSubmissionFunc={otherSubmissionFunc}
              closeApprovePaymentModal={() =>
                setState({
                  ...state,
                  showApprovePaymentModal: false,
                })
              }
            />
          )}
          {state.showCancelPaymentModal && (
            <CancelPaymentModal
              id={caseDetails.id}
              otherSubmissionFunc={otherSubmissionFunc}
              changeCancelReason={changeCancelReason}
              cancelReason={state.cancelReason}
              closeCancelPaymentModal={() =>
                setState({
                  ...state,
                  showCancelPaymentModal: false,
                })
              }
            />
          )}
          <input
            type="hidden"
            name="is_prepayment_raised"
            value={`${
              caseDetails.is_prepayment_raised
                ? caseDetails.is_prepayment_raised
                : ""
            }`}
            readOnly
          />
          <div className="row">
            <div className="particular-tab-docs" id="checklistD">
              <div className="panel panel-default">
                <div className="panel-body">
                  <div className="tab-content">
                    <div
                      role="tabpanel"
                      className="tab-pane fade in active"
                      id="tab-particulars-information"
                    >
                      <div
                        className="table-responsive chklist-box-scroll mrg-B5 payment-details-box mCustomScrollbar _mCS_2 mCS-autoHide"
                        data-mcs-theme="minimal-dark"
                      >
                        {!isVerificationRequired ? (
                          <div className="disburse-table no-form">
                            There are no verification required in this section.
                            Please click Next/Skip to proceed
                          </div>
                        ) : (
                          <div
                            id="mCSB_2"
                            className="mCustomScrollBox mCS-minimal-dark mCSB_vertical mCSB_outside"
                          >
                            <div
                              id="mCSB_2_container"
                              className="mCSB_container payment-tranche-form-main"
                            >
                              <table className="table table-bordered disburse-table">
                                <thead>
                                  <tr>
                                    <th width="76%" colSpan="2">
                                      {panelTitle} - {stepTitle}
                                    </th>
                                    {stepDetails.checklist && (
                                      <th width="24%">L1</th>
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  <CommonTrancheDetails
                                    state={state}
                                    setState={setState}
                                    formFieldState={formFieldState}
                                    handleRadioChange={handleRadioChange}
                                    handleTriggerChange={handleTriggerChange}
                                    fieldValues={fieldValues}
                                    user={user}
                                    disableMaker={disableMaker}
                                    disable={disable}
                                    disableRadioCls={disableRadioCls}
                                    cancelPartPaymentFunc={
                                      cancelPartPaymentFunc
                                    }
                                  />
                                  {formFieldState.map((payment, idx) => {
                                    console.log({ payment });
                                    if (payment.addedTranche) return "";
                                    const payCount = idx + 1;
                                    const currentFloatStatus =
                                      +state.paymentTrancheDetails?.floatResp
                                        ?.float_status || 0;

                                    // const isLastMakerPayment =
                                    //   payCount === dtsPaymentMax &&
                                    //   user.id === caseDetails.maker_id &&
                                    //   [2, 3, 4, 12, 14].includes(
                                    //     +payment.sub_stage,
                                    //   ) &&
                                    //   +caseDetails.stage === 1;

                                    const disableUploadButton =
                                      state.paymentTrancheDetails?.floatResp
                                        ?.is_proof_uploaded;
                                    // const disableFloatButtons = true;
                                    const trancheNo = getTrancheNo(payCount);

                                    const { trancheTypeCls, trancheType } =
                                      getTrancheClsAndType(
                                        payment,
                                        state,
                                        user,
                                      );

                                    const { floatColor, floatMsg } =
                                      getFloatColorAndMsg(payment.float_status);

                                    if (payCount === dtsPaymentMax) {
                                      if (btnDisplayMakerPart) {
                                        disableMaker = false;
                                        disableRadioCls = "";
                                      }
                                      if (
                                        verifyCheckBoxes(payment, user.dts_user)
                                      ) {
                                        disable = false;
                                      }
                                    }
                                    const transactionUndertaking =
                                      paymentDetails[0].transactionUndertaking;
                                    const tuComparable =
                                      transactionUndertaking[payCount] &&
                                      transactionUndertaking[payCount][
                                        +payment.payee_type
                                      ]
                                        ? transactionUndertaking[payCount][
                                            +payment.payee_type
                                          ]
                                        : [];
                                    const payeetypeList = [
                                      ...state.payeeTypeList,
                                    ];
                                    payeetypeList.unshift({
                                      text: "Select Payee Type",
                                      value: "",
                                    });
                                    const defaultPayeeType =
                                      payment.payeeTypeVal;

                                    const selectedPayerAcc = (
                                      state.payerAccount || []
                                    ).find(
                                      (acc) =>
                                        acc.value ===
                                        payment.payable_ac_number,
                                    );
                                    const otpPaymentCheck =
                                      (OTPPaymentMode.includes(
                                        payment.payment_mode,
                                      ) ||
                                        (OfflinePaymentModes.includes(
                                          payment.payment_mode,
                                        ) &&
                                          checkPayeeNameHavAcc(
                                            payment.payeeNameVal,
                                          ) &&
                                          disableValues)) &&
                                      OTPPayeeType[+defaultPayeeType] &&
                                      !!(
                                        selectedPayerAcc &&
                                        selectedPayerAcc.require_otp
                                      );
                                    if (
                                      (btnDisplayHOD ||
                                        (btnDisplayPaylead &&
                                          caseDetails.pay_head_id ===
                                            user.id)) &&
                                      payCount === dtsPaymentMax &&
                                      otpPaymentCheck
                                    ) {
                                      disableApproveBtn = true;
                                    }

                                    const payableRtgsChequeNumber = `payable_rtgs_cheque_number_${payCount}`;
                                    const checkPayableRtgsChequeNumber =
                                      checkerCheckpoints[
                                        payableRtgsChequeNumber
                                      ] === "1"
                                        ? true
                                        : false;
                                    const uncheckPayableRtgsChequeNumber =
                                      checkerCheckpoints[
                                        payableRtgsChequeNumber
                                      ] === "0"
                                        ? true
                                        : false;
                                    const cheque =
                                      payment.payable_rtgs_cheque_number
                                        ? payment.payable_rtgs_cheque_number
                                        : "";

                                    const showChequeInput =
                                      payment.showChequeInput ||
                                      (!readOnlyUser &&
                                        caseDetails.is_reassigned === 0 &&
                                        ["2", "3", "4", "12"].includes(
                                          caseDetails.sub_stage,
                                        ) &&
                                        (cheque === "" ||
                                          (cheque !== "" &&
                                            payCount === dtsPaymentMax &&
                                            user.dts_user === "MAKER"))) ||
                                      (!readOnlyUser &&
                                        cheque === "" &&
                                        caseDetails.is_reassigned === 1 &&
                                        caseDetails.sub_stage === "2") ||
                                      (!readOnlyUser &&
                                        cheque === "" &&
                                        caseDetails.sub_stage !== "2");

                                    const showTrancheChecklist =
                                      payment.pay_count < dtsPaymentMax ||
                                      payment.save_as_draft;

                                    return (
                                      <tr key={idx}>
                                        <td colSpan="5">
                                          <h4 className="tranche-title">
                                            {trancheNo} Tranche
                                            <span
                                              className={`label control-status-button ${trancheTypeCls}`}
                                            >
                                              {trancheType}
                                            </span>
                                            {["2", "3"].includes(
                                              payment.tranche_type,
                                            ) && (
                                              <button
                                                className="ic_info"
                                                style={{ marginLeft: "20px" }}
                                                title="Reasons"
                                                onClick={(e) =>
                                                  openTrancheControlModal(
                                                    payCount,
                                                    e,
                                                  )
                                                }
                                              >
                                                <img
                                                  src={`${process.env.REACT_APP_STYLES_PATH}info-icon.png`}
                                                  alt=""
                                                />
                                              </button>
                                            )}
                                          </h4>
                                          <table className="table table-bordered">
                                            <tbody>
                                              {payment.payable_ac_number !==
                                              "Direct Payment" ? (
                                                <tr
                                                  className={`pay-details-hide-${payCount}`}
                                                >
                                                  {payCount === dtsPaymentMax &&
                                                  user.id ===
                                                    caseDetails.maker_id &&
                                                  [2, 3, 4, 12, 14].includes(
                                                    parseInt(payment.sub_stage),
                                                  ) &&
                                                  caseDetails.stage === "1" ? (
                                                    <td
                                                      className="td-float"
                                                      style={{
                                                        color:
                                                          payment.floatResp &&
                                                          payment.floatResp
                                                            .float_color
                                                            ? payment.floatResp
                                                                .float_color
                                                            : getFloatColorAndMsg(
                                                                payment.float_status,
                                                              ).floatColor,
                                                      }}
                                                    >
                                                      <input
                                                        type="hidden"
                                                        name="float_status"
                                                        id="float_status"
                                                        value={
                                                          payment.floatResp
                                                            ? payment.floatResp
                                                                .float_status
                                                            : ""
                                                        }
                                                        readOnly
                                                      />
                                                      <strong
                                                        style={{
                                                          fontSize: "14px",
                                                        }}
                                                      >
                                                        Float Payment
                                                      </strong>
                                                      <br />
                                                      <span
                                                        id="float_msg_id"
                                                        style={{
                                                          fontSize: "12px",
                                                        }}
                                                      >
                                                        {payment.floatResp &&
                                                        payment.floatResp
                                                          .float_msg
                                                          ? payment.floatResp
                                                              .float_msg
                                                          : getFloatColorAndMsg(
                                                              payment.float_status,
                                                            ).floatMsg}
                                                      </span>
                                                    </td>
                                                  ) : (
                                                    <td
                                                      style={{
                                                        color: floatColor,
                                                      }}
                                                    >
                                                      <strong
                                                        style={{
                                                          fontSize: "14px",
                                                        }}
                                                      >
                                                        Float Payment
                                                      </strong>
                                                      <br />
                                                      <span
                                                        style={{
                                                          fontSize: "12px",
                                                        }}
                                                      >
                                                        {floatMsg}
                                                      </span>
                                                    </td>
                                                  )}
                                                  <RadioButtons
                                                    label=""
                                                    isRequired={false}
                                                    className={`btn tog-btn tog-positive  ${
                                                      payment.is_payment_received_by_bank ===
                                                      1
                                                        ? "active"
                                                        : ""
                                                    }`}
                                                    name={`payment_received_by_bank ${payCount}`}
                                                    disabled={disableMaker}
                                                    yesChecked={
                                                      payment.is_payment_received_by_bank ===
                                                      1
                                                    }
                                                    noChecked={
                                                      payment.is_payment_received_by_bank !==
                                                      1
                                                    }
                                                    noButtonClassName={`btn tog-btn tog-negative  ${
                                                      payment.is_payment_received_by_bank !==
                                                      1
                                                        ? "active"
                                                        : ""
                                                    }`}
                                                    showDiv={true}
                                                    DivClassName={`btn-group toggle-option ${disableRadioCls}`}
                                                    isStyledButton={true}
                                                    onYesClicked={() => {
                                                      // if (disableFloatButtons)
                                                      //   return;

                                                      handleRadioChange(
                                                        1,
                                                        idx,
                                                        "is_payment_received_by_bank",
                                                      );
                                                    }}
                                                    onNoClicked={() => {
                                                      // if (disableFloatButtons)
                                                      //   return;

                                                      handleRadioChange(
                                                        0,
                                                        idx,
                                                        "is_payment_received_by_bank",
                                                      );
                                                    }}
                                                    child={
                                                      payCount ===
                                                        dtsPaymentMax &&
                                                      user.id ===
                                                        caseDetails.maker_id &&
                                                      [
                                                        2, 3, 4, 12, 14,
                                                      ].includes(
                                                        +payment.sub_stage,
                                                      ) &&
                                                      +caseDetails.stage ===
                                                        1 ? (
                                                        <>
                                                          {!disableUploadButton && (
                                                            <RefreshButton
                                                              refreshFloatRule={
                                                                refreshFloatRuleFunc
                                                              }
                                                              spinClass={
                                                                state.spinClass
                                                              }
                                                            />
                                                          )}
                                                          {currentFloatStatus !==
                                                            1 && (
                                                            <span
                                                              style={{
                                                                marginLeft:
                                                                  "10px",
                                                              }}
                                                            >
                                                              <input
                                                                type="file"
                                                                id={`floatProof_${idx}`}
                                                                accept=".pdf,.jpg,.jpeg,.png"
                                                                style={{
                                                                  display:
                                                                    "none",
                                                                }}
                                                                onChange={(e) =>
                                                                  handleFloatProofUpload(
                                                                    e,
                                                                    idx,
                                                                  )
                                                                }
                                                              />

                                                              {!disableUploadButton ? (
                                                                <button
                                                                  type="button"
                                                                  className="btn btn-primary btn-sm"
                                                                  onClick={() =>
                                                                    document
                                                                      .getElementById(
                                                                        `floatProof_${idx}`,
                                                                      )
                                                                      ?.click()
                                                                  }
                                                                  title="Upload Float Approval"
                                                                >
                                                                  <i className="fa fa-upload"></i>
                                                                </button>
                                                              ) : (
                                                                <button
                                                                  type="button"
                                                                  className="btn btn-danger btn-sm"
                                                                  onClick={() =>
                                                                    handleFloatProofDelete(
                                                                      idx,
                                                                    )
                                                                  }
                                                                  title="Delete Float Approval"
                                                                >
                                                                  <i className="fa fa-trash"></i>
                                                                </button>
                                                              )}
                                                            </span>
                                                          )}{" "}
                                                        </>
                                                      ) : payment.float_doc_id ? (
                                                        <div
                                                          style={{
                                                            textAlign: "center",
                                                            width: "100%",
                                                            marginTop: "8px",
                                                          }}
                                                        >
                                                          <span
                                                            style={{
                                                              color: "#d9534f",
                                                              backgroundColor:
                                                                "#fdf2f2",
                                                              border:
                                                                "1px solid #f5c6cb",
                                                              borderRadius:
                                                                "4px",
                                                              padding:
                                                                "4px 10px",
                                                              fontWeight: "600",
                                                              fontSize: "12px",
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            <span
                                                              className="glyphicon glyphicon-ok-sign"
                                                              style={{
                                                                marginRight:
                                                                  "5px",
                                                              }}
                                                            ></span>
                                                            Float Approval
                                                            Uploaded.
                                                            <br />
                                                            {payment?.released_date
                                                              ? "Verification Is Done."
                                                              : "Verification Required!"}
                                                          </span>
                                                        </div>
                                                      ) : null
                                                    }
                                                  />
                                                  {stepDetails.checklist &&
                                                  showTrancheChecklist ? (
                                                    <FormTriggers
                                                      triggerName={`is_payment_received_by_bank_${payCount}`}
                                                      disabled={disable}
                                                      showYesButton={
                                                        verifyCheckBoxes(
                                                          payment,
                                                          user.dts_user,
                                                        ) ||
                                                        checkIsPaymentReceivedByBank
                                                      }
                                                      showNoButton={
                                                        verifyCheckBoxes(
                                                          payment,
                                                          user.dts_user,
                                                        ) ||
                                                        uncheckIsPaymentReceivedByBank
                                                      }
                                                      errorClass={
                                                        payment.showPaymentReceivedByBankTriggerError
                                                          ? "has-error"
                                                          : ""
                                                      }
                                                      triggerValues={
                                                        checkerCheckpoints
                                                      }
                                                      caseDetails={caseDetails}
                                                      handleTriggerChange={
                                                        handleTriggerChange
                                                      }
                                                    />
                                                  ) : (
                                                    ""
                                                  )}
                                                </tr>
                                              ) : (
                                                ""
                                              )}

                                              <PayeeAndPayerDetails
                                                payCount={payCount}
                                                state={state}
                                                formFieldState={formFieldState}
                                                setFormFieldState={
                                                  setFormFieldState
                                                }
                                                payment={payment}
                                                stepDetails={stepDetails}
                                                caseDetails={caseDetails}
                                                checkpoints={checkpoints}
                                                payeetypeList={payeetypeList}
                                                tuComparable={tuComparable}
                                                disable={disable}
                                                disableMaker={disableMaker}
                                                btnDisplayHOD={btnDisplayHOD}
                                                btnDisplayPaylead={
                                                  btnDisplayPaylead
                                                }
                                                user={user}
                                                dtsPaymentMax={dtsPaymentMax}
                                                handleInputChange={
                                                  handleInputChange
                                                }
                                                handleCheckboxChange={
                                                  handleCheckboxChange
                                                }
                                                handleTriggerChange={
                                                  handleTriggerChange
                                                }
                                                toggleDropDown={toggleDropDown}
                                                dropdownContainer={
                                                  dropdownContainer
                                                }
                                                validateOTP={validateOTP}
                                                validateAccNumberFunc={
                                                  validateAccNumberFunc
                                                }
                                                showTrancheChecklist={
                                                  showTrancheChecklist
                                                }
                                              />
                                              <BankandPaymentDetails
                                                payCount={payCount}
                                                state={state}
                                                formFieldState={formFieldState}
                                                setFormFieldState={
                                                  setFormFieldState
                                                }
                                                payment={payment}
                                                caseDetails={caseDetails}
                                                stepDetails={stepDetails}
                                                checkpoints={checkpoints}
                                                tuComparable={tuComparable}
                                                user={user}
                                                disableMaker={disableMaker}
                                                disable={disable}
                                                handleInputChange={
                                                  handleInputChange
                                                }
                                                handleTriggerChange={
                                                  handleTriggerChange
                                                }
                                                fetchBalAmount={fetchBalAmount}
                                                ifscMappingFunc={
                                                  ifscMappingFunc
                                                }
                                                compareLedgerWithDisbAmtFunc={
                                                  compareLedgerWithDisbAmtFunc
                                                }
                                                checkSuperMaker={isSuperMaker}
                                                dtsPaymentMax={dtsPaymentMax}
                                                showTrancheChecklist={
                                                  showTrancheChecklist
                                                }
                                              />
                                              {disableApproveBtn ? (
                                                <tr>
                                                  <td>
                                                    {" "}
                                                    {OfflinePaymentModes.includes(
                                                      payment.payment_mode,
                                                    )
                                                      ? "Payee/Foreclosure A/C No"
                                                      : "Enter OTP"}
                                                  </td>
                                                  <td>
                                                    <input
                                                      type="text"
                                                      id={`otp${payCount}`}
                                                      name={`otp${payCount}`}
                                                      className="form-control"
                                                      placeholder="Enter OTP"
                                                      onPaste={(e) =>
                                                        e.preventDefault()
                                                      }
                                                      value={
                                                        payment.otp
                                                          ? payment.otp
                                                          : ""
                                                      }
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          e,
                                                          idx,
                                                          "otp",
                                                        )
                                                      }
                                                      disabled={
                                                        payment.disabled_otp
                                                          ? payment.disabled_otp
                                                          : false
                                                      }
                                                    />
                                                    <span
                                                      id={`validateOTPMsg${payCount}`}
                                                      className={
                                                        payment.validateOTPClass
                                                          ? payment.validateOTPClass
                                                          : ""
                                                      }
                                                    >
                                                      {payment.validateOTPMsg
                                                        ? payment.validateOTPMsg
                                                        : ""}
                                                    </span>
                                                  </td>
                                                  <td>
                                                    <button
                                                      id={`validateOTP${payCount}`}
                                                      className="btn btn-edit"
                                                      type="button"
                                                      disabled={
                                                        payment.disabled_validateOTPBtn
                                                          ? payment.disabled_validateOTPBtn
                                                          : false
                                                      }
                                                      onClick={(e) =>
                                                        validateOTP(e, idx)
                                                      }
                                                    >
                                                      Validate
                                                    </button>
                                                  </td>
                                                </tr>
                                              ) : (
                                                ""
                                              )}
                                              <tr>
                                                <td colSpan="3">
                                                  <div className="clearfix advTxt-filter">
                                                    <button
                                                      id={`addUTR${payCount}`}
                                                      className="advSearch-filter advSearchFilter addUTRsearch"
                                                      onClick={(e) =>
                                                        toggleUTRButton(idx, e)
                                                      }
                                                    >
                                                      {!state.showUTRButton[
                                                        idx
                                                      ] ? (
                                                        <span className="fa fa-plus-square-o"></span>
                                                      ) : (
                                                        <span className="fa fa-minus-square-o"></span>
                                                      )}
                                                      Add UTR / Cheque Number
                                                    </button>
                                                  </div>
                                                </td>
                                              </tr>
                                              {state.showUTRButton[idx] ? (
                                                <tr
                                                  className={`displayUtr-${payCount}`}
                                                >
                                                  <td>UTR#</td>
                                                  <td>
                                                    {showChequeInput ? (
                                                      <>
                                                        <input
                                                          type="text"
                                                          id={
                                                            payableRtgsChequeNumber
                                                          }
                                                          value={cheque}
                                                          onChange={(e) =>
                                                            handleInputChange(
                                                              e,
                                                              idx,
                                                              "payable_rtgs_cheque_number",
                                                            )
                                                          }
                                                          name={
                                                            payableRtgsChequeNumber
                                                          }
                                                          disabled={
                                                            payment.disabled_utrNoBtn
                                                          }
                                                          placeholder="UTR / Cheque Number"
                                                          className={`form-control ${
                                                            payment.payableRtgsChequeNumberClass
                                                              ? formFieldState[
                                                                  idx
                                                                ]
                                                                  .payableRtgsChequeNumberClass
                                                              : ""
                                                          }`}
                                                          readOnly={
                                                            payment.payableRtgsChequeNumberReadOnly
                                                          }
                                                        />
                                                        {payment.errorpayableRtgsChequeNumberMsg ? (
                                                          <div
                                                            className="errorTxt"
                                                            id={`error_payable_rtgs_cheque_number_${payCount}`}
                                                          >
                                                            {
                                                              payment.errorpayableRtgsChequeNumberMsg
                                                            }
                                                          </div>
                                                        ) : (
                                                          ""
                                                        )}
                                                      </>
                                                    ) : (
                                                      <>{cheque}</>
                                                    )}
                                                  </td>
                                                  {stepDetails.checklist &&
                                                  showTrancheChecklist ? (
                                                    <FormTriggers
                                                      triggerName={
                                                        payableRtgsChequeNumber
                                                      }
                                                      disabled={disable}
                                                      showYesButton={
                                                        verifyCheckBoxes(
                                                          payment,
                                                          user.dts_user,
                                                        ) ||
                                                        checkPayableRtgsChequeNumber
                                                      }
                                                      showNoButton={
                                                        verifyCheckBoxes(
                                                          payment,
                                                          user.dts_user,
                                                        ) ||
                                                        uncheckPayableRtgsChequeNumber
                                                      }
                                                      triggerValues={
                                                        checkerCheckpoints
                                                      }
                                                      caseDetails={caseDetails}
                                                      handleTriggerChange={
                                                        handleTriggerChange
                                                      }
                                                    />
                                                  ) : (
                                                    ""
                                                  )}
                                                </tr>
                                              ) : (
                                                ""
                                              )}

                                              {utrEnabled ? (
                                                <tr
                                                  className={`displayScr-${payCount}`}
                                                ></tr>
                                              ) : (
                                                ""
                                              )}

                                              {showUTRSaveButton &&
                                              !paymentDetails[idx]
                                                .payable_rtgs_cheque_number &&
                                              utrEnabled ? (
                                                <tr
                                                  className={`displayUTRSave-${payCount}`}
                                                >
                                                  <td colSpan="3">
                                                    <div className="clearfix form-group utrWrapBtn">
                                                      <button
                                                        id={`utr_no_btn${payCount}`}
                                                        className="btn btn-edit add-utr-btn save-rto-details"
                                                        disabled={
                                                          payment.disabled_utrNoBtn
                                                        }
                                                        onClick={() =>
                                                          addUTR(idx)
                                                        }
                                                      >
                                                        Save
                                                      </button>
                                                    </div>
                                                  </td>
                                                </tr>
                                              ) : (
                                                ""
                                              )}
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                  {state.showNextTrancheCell ? (
                                    <tr>
                                      <td colSpan="5" id="nextTrancheTd">
                                        {Object.keys(state.addedTrancheData)
                                          .length ? (
                                          <AddedTranche
                                            data={state.addedTrancheData}
                                            fieldValues={fieldValues}
                                            controlSystem={
                                              state.paymentTrancheDetails
                                                .controlSystem
                                            }
                                            floatResp={
                                              state.paymentTrancheDetails
                                                .floatResp
                                            }
                                            formFieldState={formFieldState}
                                            setFormFieldState={
                                              setFormFieldState
                                            }
                                            state={state}
                                            setState={setState}
                                            fetchBalAmount={fetchBalAmount}
                                            toggleCancellationTooltip={
                                              toggleCancellationTooltip
                                            }
                                            handleRadioChange={
                                              handleRadioChange
                                            }
                                            handleTriggerChange={
                                              handleTriggerChange
                                            }
                                            refreshFloatRuleFunc={
                                              refreshFloatRuleFunc
                                            }
                                            addUTR={addUTR}
                                            ifscMappingFunc={ifscMappingFunc}
                                            changeAccTypeFunc={
                                              changeAccTypeFunc
                                            }
                                            validateAccNumberFunc={
                                              validateAccNumberFunc
                                            }
                                            compareLedgerWithDisbAmtFunc={
                                              compareLedgerWithDisbAmtFunc
                                            }
                                            checkpoints={checkpoints}
                                            handleFloatProofUpload={
                                              handleFloatProofUpload
                                            }
                                            handleFloatProofDelete={
                                              handleFloatProofDelete
                                            }
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                    </tr>
                                  ) : (
                                    ""
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}
                      </div>

                      <PaymentTrancheFormButtons
                        stepDetails={stepDetails}
                        caseDetails={caseDetails}
                        saveAsDraft={saveAsDraft}
                        user={user}
                        lastCancellationDataArr={lastCancellationDataArr}
                        isReleaseBtnDis={
                          state.paymentTrancheDetails.isAuthorizedAccess
                            ? true
                            : false
                        }
                        paymentDetails={paymentDetails}
                        checkSuperMaker={isSuperMaker}
                        disableAuthBtn={
                          paymentDetails.length
                            ? paymentDetails[paymentDetails.length - 1]
                                .disableAuthBtn
                            : true
                        }
                        disableApproveBtn={disableApproveBtn}
                        btnDisplayMakerLead={btnDisplayMakerLead}
                        state={state}
                        setState={setState}
                        addTrancheFunc={addTrancheFunc}
                        makerSubmissionFunc={makerSubmissionFunc}
                        partPaymentSubmissionFunc={partPaymentSubmissionFunc}
                        superMakerSubmissionFunc={superMakerSubmissionFunc}
                        checkerValidateFunc={checkerValidateFunc}
                        otherSubmissionFunc={otherSubmissionFunc}
                        lastFormState={
                          formFieldState[formFieldState.length - 1]
                        }
                        openApprovePaymentModal={() =>
                          setState({ ...state, showApprovePaymentModal: true })
                        }
                        openCancelPaymentModal={() =>
                          setState({ ...state, showCancelPaymentModal: true })
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}
    </>
  );
};

export default PaymentTranche;
